import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import common from "./modules/common";
import tag from "./modules/tag";

export default createStore({
  modules: {
    common,
    tag,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: ["common.token", "common.userinfo", "common.customerAuths", "common.currentPower", "tag.tagList", "common.managePower", "tag.thisCompany", "tag.tagCurrentData", "common.OEMInfo", "common.tabNum"],
    }),
  ],
});
